import type { ReactNode } from "react";
import { Glyph } from "./Glyph";
interface MenuItemBase {
  label: ReactNode;
  icon?: ReactNode;
  trailing?: ReactNode;
  isDestructive?: boolean;
  disabled?: boolean;
  isSelected?: boolean;
  section?: string;
  hasSeparatorBefore?: boolean;
}
export type MenuItem = MenuItemBase & ({
  onSelect: () => void;
  submenu?: never;
} | {
  submenu: MenuItem[];
  onSelect?: never;
});
export function MenuSectionLabel({
  children,
  role
}: {
  children: ReactNode;
  role?: "presentation";
}) {
  return <p role={role} className="px-2.5 pb-1 pt-2 text-caption font-medium text-ink-3 first:pt-1" data-sentry-component="MenuSectionLabel" data-sentry-source-file="MenuParts.tsx">
            {children}
        </p>;
}
export function MenuMoreGlyph() {
  return <Glyph name="more" className="h-[18px] w-[18px]" strokeWidth={2.75} data-sentry-element="Glyph" data-sentry-component="MenuMoreGlyph" data-sentry-source-file="MenuParts.tsx" />;
}